import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./style.css"
import "./darkMode.css"
import VModal from 'vue-js-modal'
import VueApexCharts from 'vue-apexcharts'
import { EmojiPickerPlugin } from 'vue-emoji-picker'
Vue.use(EmojiPickerPlugin)
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.use(VModal)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
